<template>
  <basic-container>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
      @refresh-change="onLoad"
    >
      <template slot="menuLeft">
        <el-button
          type="danger"
          size="small"
          icon="el-icon-delete"
          plain
          v-if="permission.firefightingword_delete"
          @click="handleDelete"
          >删 除
        </el-button>
      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
import {
  add,
  getDetail,
  getList,
  remove,
  update,
} from '@/api/v4ward/firefighting/firefightingword';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      form: {},
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      option: {
        height: 'auto',
        // calcHeight: 350,
        searchMenuSpan: 6,
        tip: false,
        border: true,
        index: true,
        viewBtn: true,
        selection: true,
        indexLabel: '序号',
        column: [
          {
            label: '消防类型',
            prop: 'type',
            rules: [
              {
                required: true,
                message: '请输入消防类型',
                trigger: 'change',
              },
            ],
            search: true,
            dicData: [
              {
                label: '安置设施',
                value: 1,
              },
              {
                label: '消防巡视',
                value: 2,
              },
              {
                label: '消防演练',
                value: 3,
              },
              {
                label: '处理事故',
                value: 4,
              },
            ],
            type: 'select',
          },
          {
            label: '处理人姓名',
            prop: 'manageUserName',
            rules: [
              {
                required: true,
                message: '请输入处理人姓名',
                trigger: 'change',
              },
            ],
            search: true,
          },
          {
            label: '处理进度',
            prop: 'manageStatus',
            rules: [
              {
                required: true,
                message: '请输入处理进度',
                trigger: 'change',
              },
            ],
            dicData: [
              {
                label: '处理中',
                value: 1,
              },
              {
                label: '处理完成',
                value: 2,
              },
            ],
            type: 'select',
            search: true,
          },
          {
            label: '处理内容',
            prop: 'content',
            rules: [
              {
                required: true,
                message: '请输入处理内容',
                trigger: 'change',
              },
            ],
          },
          {
            label: '开始时间',
            prop: 'beginTime',
            rules: [
              {
                required: true,
                message: '请输入开始时间',
                trigger: 'change',
              },
            ],
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            type: 'datetime',
            search: true,
          },
          {
            label: '结束时间',
            prop: 'finishTime',
            rules: [
              {
                required: true,
                message: '请输入结束时间',
                trigger: 'change',
              },
            ],
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            type: 'datetime',
          },
          {
            label: '备注',
            prop: 'remark',
          },
        ],
      },
      data: [],
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.firefightingword_add, false),
        viewBtn: this.vaildData(this.permission.firefightingword_view, false),
        delBtn: this.vaildData(this.permission.firefightingword_delete, false),
        editBtn: this.vaildData(this.permission.firefightingword_edit, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  methods: {
    rowSave(row, loading, done) {
      add(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowUpdate(row, index, loading, done) {
      update(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
        });
      }
      done();
    },
    searchReset() {
      this.query = {};
      this.onLoad();
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad();
      //操作结束方法
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
        ({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        }
      );
    },
  },
};
</script>

<style></style>
